import { useState, useRef, useEffect } from "react";
import { Button } from "antd";
import ReactEmojiPicker from "emoji-picker-react";

const EmojiPicker = ({ onEmojiClick }) => {
  const [open, setOpen] = useState(false);
  const pickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <Button
        type="text"
        shape="circle"
        onClick={() => setOpen(!open)}
        className="emoji-button"
      >
        😊
      </Button>

      {open && (
        <div ref={pickerRef} className="emoji-picker">
          <ReactEmojiPicker onEmojiClick={onEmojiClick} />
        </div>
      )}
    </>
  );
};

export default EmojiPicker;
